var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mr-2 mb-2 bg-red-400 dark:bg-red-800 text-gray-900 dark:text-gray-100 py-1 px-3 inline-block rounded-md shadow-md"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }